import { InlineAlertType, ItemType } from '@varo/graphql-schema-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import ContentList from 'shared/components/vxl/ContentList/ContentList';
import InlineAlert from 'shared/components/vxl/InlineAlert/InlineAlert';
import BodyBaseBoldText from 'shared/components/vxl/typography/primary/body/BodyBaseBoldText';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import theme from 'shared/styles/theme';

const MoneyInBody = () => {
  const { t: translate } = useTranslation('believe');

  const moneyInList = [
    <>
      <BodyBaseBoldText>
        {translate('application.moveMoney.bodyListBold_1')}
      </BodyBaseBoldText>

      <BodyBaseText>
        {translate('application.moveMoney.bodyListNormal_1')}
      </BodyBaseText>
    </>,
    <>
      <BodyBaseBoldText>
        {translate('application.moveMoney.bodyListBold_2')}
      </BodyBaseBoldText>
      <BodyBaseText>
        {translate('application.moveMoney.bodyListNormal_2')}
      </BodyBaseText>
    </>,
  ];

  return (
    <View style={styles.container}>
      <View>
        <ContentList itemType={ItemType.Number} contentList={moneyInList} />
      </View>
      <View style={styles.alertContainer}>
        <InlineAlert
          alertType={InlineAlertType.Brand}
          iconKeyType="EXCHANGE"
          bodyText={translate('application.moveMoney.alertBodyText')}
          isImageVisible
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  alertContainer: { marginTop: theme.spacing.m },
  container: { height: '100%' },
});

export default MoneyInBody;
